import type { APITypes, Dynamo } from '../../../../primary-record-types';

export const noteFileToNotModified = (noteFile: Dynamo.NoteFile): APITypes.notesService.NoteFileNotModified => ({
    type: 'not-modified',
    fileId: noteFile.noteFileId,
    description: noteFile.description,
});
